import React from 'react';
import { Text } from 'wix-ui-tpa/cssVars';
import { Image } from '@wix/wix-ui-icons-common';
import { classes } from '../stylesheets/signature.st.css';
export const ExternalImageWUT = _ref => {
  let {
    value
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.externalImageOverlay
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.externalImage
  }, /*#__PURE__*/React.createElement(Image, {
    className: classes.externalImageIcon
  }), /*#__PURE__*/React.createElement(Text, {
    className: classes.externalImageText
  }, value == null ? void 0 : value.displayName)));
};
//# sourceMappingURL=external-image-wut.js.map